<template>
    <modal id="field-audit-schedule-modal">
        <template slot="body">
            <field-datetime v-model="form.scheduled_at" label="Select Date &amp; Time" :inline="true"></field-datetime>
            <div class="inputs">
                <field-timezone v-model="form.timezone"></field-timezone>
                <field-checkbox v-model="form.notification_email" placeholder="Send notification email."></field-checkbox>
            </div>
            <div class="px-2 pt-2 pb-4" v-if="authorize('admin') && value.scheduled_at != null">
                <a href="#" @click="cancelSchedule()" class="text-danger">Cancel Schedule</a>
            </div>
        </template>
        <template slot="footer">
            <button class="btn btn-dafault" @click="closeModal('field-audit-schedule-modal')">
                Close
            </button>
            <button class="btn btn-success" @click="save()" :disabled="form.isSubmitted">
                <span v-if="!form.isSubmitted">Save</span>
                <span v-else><i class="fa fa-spin fa-spinner"></i> Saving...</span>
            </button>
        </template>
    </modal>
</template>
<script>
    export default {

        props: {
            value: {
                type: Object,
                required: true,
            }
        },

        data() {
            return {
                field_audit: this.value,
                form: new Form({
                    notification_email: true,
                    scheduled_at: this.value.scheduled_at ? this.mysqlDateTime(this.value.scheduled_at) : moment().format('Y-MM-DD H:mm:ss'),
                    timezone: this.value.timezone ? this.value.timezone : clientTimeZone,
                }).dontClear()
            }
        },

        watch:{
            value(val){
                this.field_audit = val;
            }
        },

        methods: {
            save: _.debounce(function () {
                this.form.patch(`/field-audits/${this.field_audit.number}`).then(response => {
                    this.closeModal('field-audit-schedule-modal');
                        var message = response.scheduled_at ? `Scheduled to ${this.shortDateTime(response.scheduled_at)}` : 'Not Schedule Defined';
                    Alert.withAction(message).then(() => {
                        this.refreshPage();
                    })
                    this.$emit('input', response)
                }).catch(errors => {
                    Alert.error(errors.first())
                })
            }, 300),

            cancelSchedule() {
                this.form.notification_email = false
                this.form.scheduled_at = null
                this.form.timezone = null
                this.save();
            },
        }
    }
</script>
